import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SharedLocalizationModule } from '@shared/localization';
import { ConfirmationDialogComponentModule } from '@shared/ui';
import { LoggerModule } from '@telespot/shared/logger/feature/util';
import { ImgFallbackModule, NavigateBackDirectiveModule, TruncatePipeModule } from '@telespot/shared/util';

@NgModule({ declarations: [],
    exports: [
        CommonModule,
        TruncatePipeModule,
        ImgFallbackModule,
        ConfirmationDialogComponentModule,
        RouterModule,
        LoggerModule,
        NavigateBackDirectiveModule,
        SharedLocalizationModule,
        MatTooltipModule,
    ], imports: [CommonModule,
        RouterModule,
        LoggerModule,
        ImgFallbackModule,
        NavigateBackDirectiveModule,
        TruncatePipeModule,
        ConfirmationDialogComponentModule,
        SharedLocalizationModule,
        MatTooltipModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule { }
